import { render, staticRenderFns } from "./SideDrawerHeader.vue?vue&type=template&id=13cc0c6f&scoped=true&"
import script from "./SideDrawerHeader.vue?vue&type=script&lang=ts&"
export * from "./SideDrawerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SideDrawerHeader.vue?vue&type=style&index=0&id=13cc0c6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc0c6f",
  null
  
)

export default component.exports